import { Locale } from 'decentraland-ui'

import * as languages from 'modules/translation/languages'

export const locales = Object.keys(languages) as Locale[]
